// extracted by mini-css-extract-plugin
export var currentPage = "pagination-module--currentPage--o3sAT";
export var page = "pagination-module--page--jYkVA";
export var paginationDot = "pagination-module--paginationDot--ZalR-";
export var paginationWrapper = "pagination-module--paginationWrapper--d6uKk";